"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "combineActions", {
  enumerable: true,
  get: function () {
    return _reduxActions.combineActions;
  }
});
Object.defineProperty(exports, "handleActions", {
  enumerable: true,
  get: function () {
    return _reduxActions.handleActions;
  }
});
Object.defineProperty(exports, "schema", {
  enumerable: true,
  get: function () {
    return _normalizr.schema;
  }
});
Object.defineProperty(exports, "merge", {
  enumerable: true,
  get: function () {
    return _merge.default;
  }
});
Object.defineProperty(exports, "normalize", {
  enumerable: true,
  get: function () {
    return _normalize.default;
  }
});
Object.defineProperty(exports, "replace", {
  enumerable: true,
  get: function () {
    return _replace.default;
  }
});
Object.defineProperty(exports, "remove", {
  enumerable: true,
  get: function () {
    return _remove.default;
  }
});
exports.createReducer = exports.serverError = exports.history = exports.feature = void 0;

var _intersection2 = _interopRequireDefault(require("lodash/fp/intersection"));

var _reduce2 = _interopRequireDefault(require("lodash/fp/reduce"));

var _reduxActions = require("redux-actions");

var _redux = require("redux");

var _history = require("../actions/history");

var _serverError = require("../actions/server-error");

var _feature = require("../actions/feature");

var _normalizr = require("normalizr");

var _merge = _interopRequireDefault(require("./merge"));

var _normalize = _interopRequireDefault(require("./normalize"));

var _replace = _interopRequireDefault(require("./replace"));

var _remove = _interopRequireDefault(require("./remove"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var _a, _b, _c;

var feature = {
  feature: (0, _reduxActions.handleActions)((_a = {}, _a[_feature.SET_FEATURE] = function (_, _a) {
    var payload = _a.payload;
    return payload;
  }, _a), null)
};
exports.feature = feature;
var history = {
  history: (0, _reduxActions.handleActions)((_b = {}, _b[(0, _reduxActions.combineActions)(_history.PUSH, _history.GO_BACK, _history.GO_FORWARD, _history.REPLACE, _history.GO, _history.INIT)] = function (_, _a) {
    var payload = _a.payload;
    return payload;
  }, _b), null)
};
exports.history = history;
var serverError = {
  serverError: (0, _reduxActions.handleActions)((_c = {}, _c[_serverError.THROW_SERVER_ERROR] = function (state, action) {
    var _a;

    return __assign(__assign({}, state), (_a = {}, _a[new Date().toISOString()] = action, _a));
  }, _c), {})
};
exports.serverError = serverError;

var createReducer = function (entityReducers) {
  return __assign(__assign(__assign(__assign({}, serverError), history), feature), {
    entities: (0, _redux.combineReducers)(__assign({}, (0, _reduce2.default)(function (result, item) {
      var duplicatedKeys = (0, _intersection2.default)(Object.keys(item))(Object.keys(result));

      if (duplicatedKeys.length > 0) {
        console.warn("Duplicated entity reducer keys: " + duplicatedKeys.join(', '));
      }

      return __assign(__assign({}, result), item);
    }, {})(entityReducers)))
  });
};

exports.createReducer = createReducer;